/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */

import type { ITheme } from '@fluentui/react'
import styled from 'styled-components'

// always ensure the header is dark, regardless of mode
export const Container = styled.div`
	padding: 0 28px 0 28px;
	background: #12082B;
	border-bottom: 1px solid
		${({ theme }: { theme: ITheme }) =>
			theme.isInverted
				? theme.palette.neutralTertiary
				: theme.palette.neutralSecondary};
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	height: 50px;
`

export const Title = styled.h2`
	cursor: pointer;
	display: flex;
	align-items: center;
	font-size: 25px;
	align-self: center;
	margin: 0;
	padding: 0;
	font-size: 18px !important;
	backgroi: #fff !important;
`
